

























































import { defineComponent, ref, Ref, computed, watch, onMounted, getCurrentInstance } from '@vue/composition-api';
import { CheckCircleFilledIcon, DownloadIcon } from 'tdesign-icons-vue';

import i18n, { i18n_t } from '@/locales/i18n';
import { exportExcelInBrowser, exportExcelInPC, phoneCompose } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { IS_BROWSER, IS_PRIVATE } from '@/common/constant/platform';
import { getDownloadPath } from '@/renderer/scripts/utils/download/downloadHelper';
import SMHErrorCodeMap from '@/renderer/scripts/utils/errorCode/smhErrorCodeMap';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import importHandler from '../compositions/importHandler';

export default defineComponent({
  components: {
    CheckCircleFilledIcon,
    DownloadIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    resultList: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { resultColumns: columns, templateColumns } = importHandler();
    const total = ref(0);
    const errList: Ref<CoFile.ResultMap[]> = ref([]);
    const hasUserLimitError = ref(false);
    const methods = {
      onConfirm() {
        innerShow.value = false;
        context.emit('upload-finish');
      },
      onCancel() {
        const { orgChannel, orgId, channelUpdated, instanceId } = store.getters;
        if (hasUserLimitError.value) {
          if (orgChannel && !channelUpdated) {
            dispatchRouter(`${CONSTANT_URL.channelBuyUrl}&orgId=${orgId}&instanceId=${instanceId}`);
            return;
          }
          dispatchRouter(CONSTANT_URL.consoleManagementUrl);
          return;
        }
        innerShow.value = false;
        context.emit('upload-again');
      },
      async exportErrList() {
        const exportColumns = templateColumns.map(item => item.title);
        exportColumns.push(i18n_t('失败原因'));
        const exportRecords: any[] = [];
        errList.value.forEach(item => {
          const arr = [
            item.name || '',
            '',
            item.personalSpaceQuota || '',
            item.teamPath ? item.teamPath.join('/') : '',
            item.message,
          ];

          const phoneNumber =
            (item.countryCode === '+86' ? item.phoneNumber : `${item.countryCode}-${item.phoneNumber}`) || '';
          const accountName = item.accountName || '';
          arr[1] = store.getters.onlyPasswordLogin ? accountName : phoneNumber;
          exportRecords.push(arr);
        });
        if (IS_BROWSER) {
          exportExcelInBrowser(exportColumns, exportRecords, i18n_t('失败列表.xlsx'));
        } else {
          const downloadPath = await getDownloadPath();
          if (!downloadPath) return;
          exportExcelInPC(exportColumns, exportRecords, i18n_t('失败列表.xlsx'), downloadPath);
        }
      },
    };
    watch(innerShow, newVal => {
      if (newVal) {
        total.value = props.resultList.length;
        errList.value = (props.resultList as CoFile.ResultMap[]).filter(item => Math.floor(item.status / 100) !== 2);
        errList.value = errList.value.map((item, index) => {
          const { code, inner } = item;
          let errorCode = code;
          if (code === 'SmartMediaHostingError' && inner) {
            errorCode = inner;
          }
          if (code === 'UserLimitReached' && !IS_PRIVATE) {
            hasUserLimitError.value = true;
          }
          return {
            ...item,
            index: index + 1,
            team: item.teamPath.join('/'),
            // 空间转为GB显示
            personalSpaceQuota: item.personalSpaceQuota ? `${+item.personalSpaceQuota / 1024 / 1024 / 1024}` : '',
            // message用code翻译
            message:
              errorCode === 'UserLimitReached' ? i18n_t('企业人员数量已满') : SMHErrorCodeMap[errorCode] || errorCode,
          };
        });
      }
    });
    return {
      innerShow,
      columns,
      total,
      errList,
      hasUserLimitError,
      ...methods,
      phoneCompose,
    };
  },
});
